import { Masonry } from '@leagueplatform/masonry';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MASONRY } from 'common/constants';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';
import { useQueryParams } from '@leagueplatform/routing';
import { persistInPersonLandingParams } from 'utils/book-appointment-location-state';

export const InPersonConsultationPage = () => {
  usePageViewAnalytics({ screen_name: 'Book In Person Consultation' });
  const params = useQueryParams();
  const { search } = useLocation();
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_BOOK_IN_PERSON_CONSULTATION' }));

  // The in-person booking flow routes into care-finder via a backend masonry
  // navigation that drops the landing page query params, so stash them here to
  // restore when the user exits the booking flow back to this page.
  useEffect(() => {
    persistInPersonLandingParams(search);
  }, [search]);

  return (
    <MasonryPageLayout showBackButton>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_IN_PERSON_CONSULTATION_PAGE}
        initialQueryParams={Object.fromEntries(params)}
      />
    </MasonryPageLayout>
  );
};
